(function() {
    $(document).ready(function() {

        const primaryCtaButtons = $('.ctaContainer .buttonPrimary');
        const secondaryCtaButtons = $('.ctaContainer .buttonSecondary');
        const links = $('.ctaSuggestions .textContainer a');

        primaryCtaButtons.each(function() {
            const eventAction = getActionType(getProductKey(this), true, 'seen');
            activateTracking(eventAction);
        });

        secondaryCtaButtons.each(function() {
            const eventAction = getActionType(getProductKey(this), false, 'seen');
            activateTracking(eventAction);
        });

        links.each(function() {
            const eventAction = getActionType(getProductKey(this), false, 'seen');
            activateTracking(eventAction);
        });

        $('.ctaContainer .buttonPrimary').on('click', function() {
            const eventAction = getActionType(getProductKey(this), true, 'clicked');
            activateTracking(eventAction);
        });

        $('.ctaContainer .buttonSecondary').on('click', function() {
            const eventAction = getActionType(getProductKey(this), false, 'clicked');
            activateTracking(eventAction);
        });

        $('.textContainer a').on('click', function() {
            const eventAction = getActionType(getProductKey(this), false, 'clicked');
            activateTracking(eventAction);
        });

        function getProductKey(element) {
            return element.closest('.flexContainer, .wide').getAttribute('data-product');
        }

        function getActionType(productKey, isPrimary, actionType) {
            let action = '';
            if (isPrimary) {
                action = '_leistunganpassen_';
            } else {
                switch (productKey) {
                    case 'phv':
                        action = '_vergleichen_';
                        break;
                    case 'rs':
                        action = '_neueAdresse_';
                        break;
                    default:
                        action = '_datenaktualisieren_';
                        break;
                }
            }
            return productKey + action + actionType;
        }

        function activateTracking(eventAction) {
            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                eventAction,
            ]);
        }
    });
})();
